import { useContext } from "react";

import { AuthUserContext, AuthUserContextType } from "@/providers/AuthUser";

export const useAuthUser = (): AuthUserContextType => {
  return useContext<AuthUserContextType>(AuthUserContext);
};
